/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Tab_OverviewInputs */

const en_directory_agent_readiness_tab_overview = /** @type {(inputs: Directory_Agent_Readiness_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_directory_agent_readiness_tab_overview = /** @type {(inputs: Directory_Agent_Readiness_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Directory_Agent_Readiness_Tab_OverviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_tab_overview = /** @type {((inputs?: Directory_Agent_Readiness_Tab_OverviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Tab_OverviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_tab_overview(inputs)
	return zh_directory_agent_readiness_tab_overview(inputs)
});
export { directory_agent_readiness_tab_overview as "directory.agent_readiness.tab.overview" }